import { DescendantData, RichTextValue, SlateElementType } from '@vedalib/rich-text'
import {
  isBlockElement,
  isInlineElement,
  isListElement,
  isTextNode,
} from '@vedalib/rich-text/lib/types/guards'

const MAX_LEN = 65

export function generateAccessibleTitleFromRichText(
  nodes: RichTextValue,
  options: {
    index: number
    total: number
    imageAlt?: string
  },
): string {
  const shortTitle = fromHeading(nodes) || fromText(nodes) || options.imageAlt

  const position = `${'Point'} ${options.index + 1} of ${options.total}`

  return shortTitle ? `${position}: ${shortTitle}` : position
}

function fromHeading(nodes: RichTextValue): string | null {
  for (const node of nodes) {
    if (
      isBlockElement(node) &&
      (node.type === SlateElementType.heading1 ||
        node.type === SlateElementType.heading2 ||
        node.type === SlateElementType.heading3 ||
        node.type === SlateElementType.heading4)
    ) {
      const text = extractText(node)
      return normalize(text)
    }
  }
  return null
}

function fromText(nodes: RichTextValue): string | null {
  for (const node of nodes) {
    if (isListElement(node) || isInlineElement(node) || isBlockElement(node)) {
      const text = normalize(extractText(node))
      if (isMeaningful(text) && text) {
        return truncate(text)
      }
    }
  }
  return null
}

function extractText(node: DescendantData): string {
  if (isTextNode(node)) {
    return node.text
  }

  if ('children' in node && Array.isArray(node.children)) {
    return node.children.map(extractText).join(' ')
  }

  return ''
}

function normalize(text?: string | null): string | null {
  if (!text) {
    return null
  }

  return text
    .replace(/\s+/g, ' ')
    .replace(/[.:;]+$/, '')
    .trim()
}

function truncate(text: string): string {
  if (text.length <= MAX_LEN) {
    return text
  }

  const cut = text.lastIndexOf(' ', MAX_LEN)
  return cut > 0 ? text.slice(0, cut) : text.slice(0, MAX_LEN)
}

function isMeaningful(text?: string | null): boolean {
  if (!text || text.length < 5) {
    return false
  }

  const lower = text.toLowerCase()
  if (lower.startsWith('click') || lower.startsWith('use') || lower.startsWith('press')) {
    return false
  }

  if (/^https?:\/\//.test(lower)) {
    return false
  }

  return true
}
